import { Injectable } from '@angular/core';
import {
  CreateOrganizationLicenseInput,
  LicenseStatus,
  UpdateOrganizationLicenseInput
} from '../../../services/organization/organization-license.interface';
import { License } from '../interfaces/organization-license.interface';

/**
 * Service responsible for building API payloads for license operations.
 */
@Injectable({ providedIn: 'root' })
export class LicensePayloadBuilderService {
  /**
   * Builds a single update payload for a license.
   * @param license - The license data from the dialog form.
   * @param tenantId - The tenant ID to associate the license with.
   * @param environmentId - The environment ID to scope the license to.
   * @returns An update input payload for the API.
   */
  public buildUpdatePayload(
    license: License,
    tenantId: string,
    environmentId: string
  ): UpdateOrganizationLicenseInput {
    return {
      id: license.id ?? '',
      isActive: license.isActive ?? true,
      status: license.isActive ? LicenseStatus.ACTIVE : LicenseStatus.CANCELLED,
      planId: license.planId,
      maxUsers: license.maxUsers,
      metadata: null,
      expiresOnUtc: license.expiresOnUtc.toISOString(),
      activatedOnUtc: license.activatedOnUtc.toISOString(),
      tenantId,
      environmentId
    };
  }

  /**
   * Builds a single create payload for a license.
   * @param license - The license data from the dialog form.
   * @param tenantId - The tenant ID to associate the license with.
   * @param environmentId - The environment ID to scope the license to.
   * @returns A create input payload for the API.
   */
  public buildCreatePayload(
    license: License,
    tenantId: string,
    environmentId: string
  ): CreateOrganizationLicenseInput {
    return {
      isActive: license.isActive ?? true,
      status: license.isActive ? LicenseStatus.ACTIVE : LicenseStatus.CANCELLED,
      planId: license.planId,
      maxUsers: license.maxUsers,
      metadata: null,
      expiresOnUtc: license.expiresOnUtc.toISOString(),
      activatedOnUtc: license.activatedOnUtc.toISOString(),
      tenantId,
      environmentId
    };
  }
}
